module.exports = __webpack_public_path__ + "img/cp-ad-b.9d2b1964.png";